import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route , Link , Switch } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker';

function asyncComponent(importComponent) {
  	class AsyncComponent extends Component {
	    constructor(props) {
	      	super(props);
	
	      	this.state = {
	        	component: null
	      	};
	    }
	
	    async componentDidMount() {
	      	const { default: component } = await importComponent();
	
	      	this.setState({
	        	component: component
	      	});
	    }
	
	    render() {
	      	const C = this.state.component;
	      	return C ? <C {...this.props} /> : null;
	    }
  	}
  return AsyncComponent;
}
// 自定义组件
//加载首页
//import IndexPage from "./index/index"
const IndexPage=asyncComponent(()=>import(/* webpackChunkName: "IndexPage" */"./index/index"))
//二手房列表
//import ListPage from "./esfHouseList/list"
const ListPage=asyncComponent(()=>import(/* webpackChunkName: "ListPage" */"./esfHouseList/list"))
//二手房详情
//import EsfHouseDetail from "./esfHouseDetail/index";
const EsfHouseDetail=asyncComponent(()=>import(/* webpackChunkName: "EsfHouseDetail" */"./esfHouseDetail/index"))
//租房列表页
//import RenListPage from "./renHouseList/list"
const RenListPage=asyncComponent(()=>import(/* webpackChunkName: "RenListPage" */"./renHouseList/list"))
//租房详情
//import RentHouseDetail from "./rentHouseDetail/index";
const RentHouseDetail=asyncComponent(()=>import(/* webpackChunkName: "RentHouseDetail" */"./rentHouseDetail/index"))
//经纪人列表
//import BrokerList from "./brokerlist/list"
const BrokerList=asyncComponent(()=>import(/* webpackChunkName: "BrokerList" */"./brokerlist/list"))
//业务办理查询
//import Business from "./business/index"
const Business=asyncComponent(()=>import(/* webpackChunkName: "Business" */"./business/index"))
//快速委托
//import Trust from "./trust/index"
const Trust=asyncComponent(()=>import(/* webpackChunkName: "Trust" */"./trust/index"))
//资讯
//import {InfoList,InfoNewsDetail} from "./infomation/index"
const InfoList=asyncComponent(()=>import(/* webpackChunkName: "InfoList" */"./infomation/index"))
const InfoNewsDetail=asyncComponent(()=>import(/* webpackChunkName: "InfoNewsDetail" */"./infomationDetail/index"))
//小区
//import VillageList from "./villageList/index"
const VillageList=asyncComponent(()=>import(/* webpackChunkName: "VillageList" */"./villageList/index"))
//小区详情
//import villageDetail from "./villageDetail/index";
const villageDetail=asyncComponent(()=>import(/* webpackChunkName: "villageDetail" */"./villageDetail/index"))
//计算器
//import Calculator from "./calculator";
const Calculator=asyncComponent(()=>import(/* webpackChunkName: "list" */"./calculator"))
//公用渲染输出页面
const CustomMain=asyncComponent(()=>import(/* webpackChunkName: "list" */"./custom/index"))
ReactDOM.render((
    <BrowserRouter>
        <Switch>
            <Route exact path="/" component={IndexPage} />
            <Route path="/esfHouseDetail" component={EsfHouseDetail} />
            <Route path="/rentHouseDetail" component={RentHouseDetail} />
            <Route path="/esfHouseList" component={ListPage} />
            <Route path="/renHouseList" component={RenListPage} />
            <Route path="/brokerlist" component={BrokerList} />
            <Route path="/business" component={Business} />
            <Route path="/trust" component={Trust} />
            <Route path="/infolist" component={InfoList} />
            <Route path="/infoNewsDetail" component={InfoNewsDetail} />
            <Route path="/villageList" component={VillageList} />
            <Route path="/villageDetail" component={villageDetail} />
            <Route path="/calculator" component={Calculator} />
            <Route path="/custom" component={CustomMain} />
        </Switch>
    </BrowserRouter>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js